const firstFiniteNumber = (values, fallback = 0) => {
    for (const value of values) {
        if (value === null || value === undefined || value === '') continue;
        const number = Number(value);
        if (Number.isFinite(number)) return number;
    }
    return fallback;
};

export const getPlanProfitMetrics = (item = {}) => {
    const revenue = firstFiniteNumber([item.revenue, item.total_sales]);
    const productCost = firstFiniteNumber([item.product_cost]);
    const platformCommission = firstFiniteNumber([item.platform_commission]);
    const paidReferralCommission = firstFiniteNumber([
        item.paid_referral_commission,
        item.paid_commission,
        item.total_paid_commission,
    ]);
    const pendingReferralCommission = firstFiniteNumber([
        item.pending_referral_commission,
        item.pending_commission,
        item.total_pending_commission,
    ]);
    const orders = firstFiniteNumber([item.orders, item.sales_count]);
    const grossProfit = firstFiniteNumber([item.gross_profit], revenue - productCost);
    const netProfit = firstFiniteNumber(
        [item.net_profit, item.total_net_profit],
        grossProfit - platformCommission - paidReferralCommission,
    );
    const netProfitIfAllPaid = firstFiniteNumber(
        [item.net_profit_if_all_paid],
        netProfit - pendingReferralCommission,
    );

    return {
        revenue,
        productCost,
        grossProfit,
        platformCommission,
        paidReferralCommission,
        pendingReferralCommission,
        netProfit,
        netProfitIfAllPaid,
        orders,
        profitPerOrder: orders > 0
            ? firstFiniteNumber([item.profit_per_order], netProfit / orders)
            : null,
        marginPct: orders > 0 && revenue !== 0
            ? firstFiniteNumber([item.margin_pct], (netProfit / revenue) * 100)
            : null,
    };
};

export const formatReportNumber = (value, maximumFractionDigits = 4) => {
    if (value === null || value === undefined || value === '') return '—';
    const number = Number(value);
    if (!Number.isFinite(number)) return '—';
    return new Intl.NumberFormat('fa-IR', { maximumFractionDigits }).format(number);
};

export const formatReportCurrency = (value) => {
    const formatted = formatReportNumber(value);
    return formatted === '—' ? formatted : `${formatted} ریال`;
};

export const formatReportCount = (value) => formatReportNumber(value, 0);

export const formatReportPercent = (value) => {
    const formatted = formatReportNumber(value, 2);
    return formatted === '—' ? formatted : `${formatted}٪`;
};
